import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=317623ec&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=ts"
export * from "./AdminDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317623ec",
  null
  
)

export default component.exports